import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSpinnerComponent } from './ngx-spinner.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NgxSpinnerComponent],
  exports: [NgxSpinnerComponent]
})
export class NgxSpinnerModule { }
